import type { BlogPost } from "./blog";

export const BLOG_RESTAURANTS_PART2: BlogPost[] = [
  {
    "slug": "restorany-dlya-semyy-spb",
    "title": "Рестораны для семейного ужина в СПб: куда пойти с детьми",
    "metaTitle": "Рестораны для семейного ужина в СПб — Паруса на крыше",
    "metaDescription": "Рестораны для семейного ужина в Санкт-Петербурге. Где комфортно поесть всей семьёй? «Паруса на крыше» — детское меню, просторный зал, авторская кухня.",
    "keywords": "семейный ужин ресторан спб, рестораны для семьи петербург, рестораны с детьми спб",
    "date": "2026-06-10",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Ресторан для семейного ужина — особая задача. Нужно место, где комфортно и детям, и взрослым, где не придётся торопиться и где кухня нравится всем.",
    "sections": [
      {
        "heading": "Что важно в семейном ресторане",
        "body": "Семейный ресторан должен закрывать несколько потребностей одновременно: детское меню или адаптированные блюда для маленьких гостей, просторный зал без ощущения тесноты, допустимый уровень шума (дети могут шуметь — это нормально), и кухня, которая нравится разным возрастам. В «Парусах на крыше» это реализовано: большой зал, разнообразное меню от лёгких закусок до основательных горячих блюд, персонал привыкший работать с семьями.",
        "list": [
          "Просторный зал — места хватает для колясок и активных детей",
          "Детское меню — по запросу при бронировании",
          "Кухня для разных вкусов: от лёгкого до сытного",
          "Вид на Петербург — интерактивный способ рассказать детям о городе"
        ]
      },
      {
        "heading": "Лучшее время для семейного ужина",
        "body": "С детьми комфортнее приходить в ранний вечер: 17:00–19:00, когда ресторан ещё не заполнен и персонал уделяет больше внимания. В этот период также лучший дневной свет для вида из окна — хорошо для фотографий и разговоров о городе.",
        "highlight": "При бронировании семейного ужина сообщите возраст детей — официант поможет с выбором блюд и принесёт хлеб сразу."
      },
      {
        "heading": "Что заказывать детям",
        "body": "Авторская кухня «Парусов» предлагает блюда, понятные детям: паста, авторская пицца, рыбные блюда без лишних специй, лёгкие закуски. Десерты: авторские сладкие позиции от шефа хорошо принимаются детьми. Напитки: свежевыжатые соки, авторские лимонады, компот. При специальных пожеланиях (аллергия, диета) — сообщите при бронировании."
      }
    ],
    "cta": {
      "text": "Забронировать семейный ужин",
      "href": "/"
    }
  },
  {
    "slug": "restorany-pary-spb",
    "title": "Лучшие рестораны для пары в СПб: романтика и уют",
    "metaTitle": "Лучшие рестораны для пары в СПб — Паруса на крыше",
    "metaDescription": "Лучшие рестораны для пары в Санкт-Петербурге. Приватность, атмосфера, вид на город. «Паруса на крыше» — романтика с панорамой исторического центра.",
    "keywords": "рестораны для пары спб, лучший ресторан для двоих петербург, ресторан пара романтика спб",
    "date": "2026-06-10",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Ресторан для пары — особая история. Здесь важны детали: расстояние между столами, освещение, возможность говорить без того, чтобы тебя слышали соседи.",
    "sections": [
      {
        "heading": "Что делает ресторан идеальным для пары",
        "body": "Четыре критерия: приватность (угловые столики, расстояние между соседями), освещение (мягкое и тёплое, не яркое), звук (можно говорить вполголоса — живая музыка как фон, не перебивает), вид (есть тема для разговора без усилий). «Паруса» закрывают все четыре.",
        "list": [
          "Угловые столики у панорамного окна — лучшие для пары",
          "Живой джаз вполголоса — фон, не конкурент разговору",
          "Вид меняется с часами — темы для разговора сами появляются",
          "Свечи вечером — стандарт сервиса"
        ]
      },
      {
        "heading": "Как создать особый вечер для двоих",
        "body": "При бронировании: укажите «романтический ужин» и «столик у окна». Дополнительно: шампанское к приходу партнёра (согласовывается заранее), живые цветы на столе, именная карта меню. Это небольшие детали, которые из обычного ужина делают событие.",
        "highlight": "Пятница + живая музыка + закат над Петербургом = идеальный вечер для пары. Бронируйте пятничный столик за 3–5 дней заранее."
      },
      {
        "heading": "Цены для ужина для пары",
        "body": "Ужин для двоих в «Парусах»: 2 600–5 000 ₽ в зависимости от выбора блюд и напитков. С шампанским: +1 200–2 000 ₽ за бутылку. Итого: 3 800–7 000 ₽ на двоих за особый вечер с видом на Петербург — разумная сумма для такого опыта."
      }
    ],
    "cta": {
      "text": "Забронировать ужин для пары",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "restorany-bolshoy-kompaniy-peterburg",
    "title": "Рестораны для большой компании в Петербурге: форматы",
    "metaTitle": "Рестораны для большой компании в Петербурге — Паруса на крыше",
    "metaDescription": "Рестораны для большой компании в Санкт-Петербурге. Где организовать ужин на 20–100+ человек? «Паруса на крыше» — банкетный зал до 300 гостей с видом на город.",
    "keywords": "рестораны большая компания петербург, ресторан 50 человек спб, зал для большой компании петербург",
    "date": "2026-06-10",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Ресторан для большой компании — совсем другая задача, чем ресторан для двоих. Нужны пространство, синхронный сервис, возможность для тостов и программы.",
    "sections": [
      {
        "heading": "Что нужно для большой группы",
        "body": "При компании 30+: выделенное пространство (не мешать другим гостям и самим не мешать), синхронная подача блюд (все едят одновременно), микрофон для тостов и ведущего, технические возможности (экран, звук). В «Парусах» банкетный зал на 300 гостей оснащён всем необходимым: профессиональная сцена, звук, свет, свой вход.",
        "list": [
          "Банкетный зал до 300 гостей — максимальный размер в центре СПб",
          "Профессиональная сцена и звук — всё в комплекте",
          "Выделенный персонал для группы",
          "Банкетное меню от 2 500 ₽/чел."
        ]
      },
      {
        "heading": "Форматы для больших групп",
        "body": "Сидячий банкет: все за столами, блюда по меню. Коктейльный фуршет: гости стоят и общаются, лёгкие закуски. Гибридный: фуршет на приветствие, затем переход к столу. В «Парусах» доступны все три — выбор зависит от цели мероприятия.",
        "highlight": "Для группы 50+ человек: звоните заранее, менеджер сориентирует по форматам и стоимости. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Бронирование больших групп",
        "body": "Большие группы (30+) бронируются с предоплатой и договором. Рекомендуем: за 4–6 недель до мероприятия, для декабрьских дат — за 2–3 месяца. При бронировании согласуйте меню, тайминг подачи и технические потребности."
      }
    ],
    "cta": {
      "text": "Обсудить мероприятие для большой компании",
      "href": "/banket"
    }
  },
  {
    "slug": "restorany-privatnym-zalom-spb",
    "title": "Рестораны с приватными залами в СПб: список и цены",
    "metaTitle": "Рестораны с приватным залом в СПб — Паруса на крыше",
    "metaDescription": "Рестораны с приватным залом в Санкт-Петербурге. Где снять зал для мероприятия? «Паруса на крыше» — отдельный зал до 300 гостей с видом на Петербург.",
    "keywords": "рестораны приватный зал спб, снять зал ресторан петербург, приватный зал мероприятие петербург",
    "date": "2026-06-10",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Приватный зал в ресторане — формат, который решает сразу несколько задач: изолированность от других гостей, возможность шуметь и тостовать, технические возможности для программы.",
    "sections": [
      {
        "heading": "Зачем нужен приватный зал",
        "body": "Три причины арендовать приватный зал: конфиденциальность (деловые переговоры, закрытые мероприятия), возможность программы (ведущий, музыка, тосты — без помех другим), полный контроль атмосферы (декор, рассадка, тайминг). В «Парусах» банкетный зал предоставляется при заказе банкетного меню — аренда входит в стоимость.",
        "list": [
          "Отдельный вход в зал — гости только ваши",
          "Полное оборудование: сцена, звук, свет, экран",
          "Расстановка столов по вашему запросу",
          "Вид на Петербург из зала — главное украшение без затрат"
        ]
      },
      {
        "heading": "Как устроено бронирование зала",
        "body": "Приватный зал предоставляется при заказе банкетного меню или à la carte на минимальную сумму — уточняется у менеджера. Аренда зала отдельно не взимается. Минимальная сумма зависит от размера группы и дня недели.",
        "highlight": "Экскурсия по залу перед бронированием: позвоните и договоритесь об осмотре. Менеджер покажет все форматы расстановки. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Размеры залов и вместимость",
        "body": "Малый зал (выделенная зона): 10–30 гостей. Средний зал (банкетный): 30–100 гостей. Большой зал: 100–300 гостей. Все варианты — с видом на Петербург. Летом дополнительно: открытая терраса."
      }
    ],
    "cta": {
      "text": "Узнать о приватных залах",
      "href": "/banket"
    }
  },
  {
    "slug": "restorany-detskoe-menu-peterburg",
    "title": "Рестораны с детским меню в Петербурге: где вкусно детям",
    "metaTitle": "Рестораны с детским меню в Петербурге — Паруса на крыше",
    "metaDescription": "Рестораны с детским меню в Санкт-Петербурге. Где поесть с детьми в центре города? «Паруса на крыше» — адаптированное меню для детей, просторный зал.",
    "keywords": "рестораны детское меню петербург, ресторан с детьми спб, куда пойти с детьми поесть петербург",
    "date": "2026-06-11",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Ресторан с детьми — испытание для родителей и персонала. Но правильный ресторан превращает семейный ужин в удовольствие для всех.",
    "sections": [
      {
        "heading": "Что должен предложить ресторан с детьми",
        "body": "Необходимый минимум: блюда без острых специй и аллергенов, доступные для детей — паста, рыба, куриные блюда. Хорошо: детское меню с понятными названиями и позитивной подачей. Отлично: высокий стул для маленьких, добрый персонал, пространство для активного ребёнка. В «Парусах» нет специальной детской зоны, но есть всё остальное: большой зал, детские блюда по запросу, понимающий персонал.",
        "list": [
          "Детское меню — по запросу при бронировании",
          "Блюда без острых специй — адаптированы по запросу",
          "Просторный зал — место для активного ребёнка",
          "Вид на Петербург — способ занять ребёнка разговором о городе"
        ]
      },
      {
        "heading": "Возрасты: для кого подходит ресторан",
        "body": "С малышами (0–3): лучше ранний вечер (17:00–18:00), тихо, места хватает. С детьми дошкольного возраста (3–7): объясните про вид, попросите персонала показать купола. С детьми школьного возраста (7+): это отличное место — красивый вид, вкусная еда, возможность рассказать о Петербурге.",
        "highlight": "Лайфхак: попросите официанта рассказать детям, что видно из окна. Хороший персонал превращает ужин в небольшую экскурсию."
      },
      {
        "heading": "Что заказывать детям",
        "body": "Безопасный выбор: паста с томатным или сливочным соусом, рыбные блюда без лишних специй, куриные позиции. Десерты: авторские сладкие позиции нравятся детям любого возраста. Напитки: свежие соки, лимонады без газа, компоты."
      }
    ],
    "cta": {
      "text": "Забронировать семейный столик",
      "href": "/"
    }
  },
  {
    "slug": "kuda-poyti-peterburg-vecherom",
    "title": "Куда пойти в Петербурге вечером: идеи и рестораны",
    "metaTitle": "Куда пойти в Петербурге вечером 2026 — Паруса на крыше",
    "metaDescription": "Куда пойти в Петербурге вечером? Рестораны, прогулки, концерты. «Паруса на крыше» — ужин с видом на вечерний город, живая музыка по пятницам и субботам.",
    "keywords": "куда пойти петербург вечером, вечер петербург куда пойти, что делать вечером в петербурге",
    "date": "2026-06-11",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Петербург — вечерний город. Здесь огни набережных, подсветка куполов и живая музыка в ресторанах создают особую атмосферу, которая начинается после 18:00.",
    "sections": [
      {
        "heading": "Варианты вечера в Петербурге",
        "body": "Театр: Мариинский, БДТ, Александринский — нужно планировать заранее. Концерт: джаз в клубах, классика в филармонии. Ужин в хорошем ресторане: самый доступный и гибкий формат. Прогулка + ужин: комбо, которое работает всегда. В «Парусах на крыше» ужин с видом на вечерний Петербург — самостоятельный вечерний опыт, не требующий дополнительной программы.",
        "list": [
          "Ужин в «Парусах»: 19:00–22:00 + вид на вечерний Петербург",
          "Живая музыка: пятница и суббота по расписанию",
          "Прогулка до/после: от ресторана 10 минут до Невского",
          "Разводка мостов: ночная прогулка после ужина"
        ]
      },
      {
        "heading": "Вечерний маршрут с ужином в центре",
        "body": "Рекомендуемый маршрут: прогулка по каналу Грибоедова (15:00–18:00) → ужин в «Парусах» в 18:30–21:00 с видом на Петербург → прогулка по набережной → опционально: разводка мостов (01:00+). Этот маршрут даёт полный вечерний опыт Петербурга.",
        "highlight": "Самый красивый момент вечера в «Парусах»: 19:00–20:30 — переход от заката к огням города. Бронируйте именно на это время."
      },
      {
        "heading": "Вечер в зависимости от дня недели",
        "body": "Понедельник-четверг: тихий ужин, нет толп, более приватная атмосфера. Пятница: живая музыка, активный вечер, хорошее настроение в зале. Суббота: живая музыка + максимальная атмосфера, бронировать за 5–7 дней. Воскресенье: спокойный семейный/парный ужин, часто меньше гостей, чем в субботу."
      }
    ],
    "cta": {
      "text": "Забронировать вечерний столик",
      "href": "/"
    }
  },
  {
    "slug": "restorany-vremenno-poseshchat-peterburg",
    "title": "Рестораны Петербурга, куда стоит возвращаться",
    "metaTitle": "Рестораны Петербурга куда возвращаются — Паруса на крыше",
    "metaDescription": "Рестораны Петербурга, в которые хочется возвращаться. Что делает ресторан «любимым»? «Паруса на крыше» — 15 лет лояльных гостей, рейтинг 5,0.",
    "keywords": "рестораны петербург возвращаться, любимый ресторан петербург, постоянные гости ресторан спб",
    "date": "2026-06-11",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Ресторан, в который хочется возвращаться — отдельная категория. Это не обязательно самый дорогой или самый модный. Это место, где помнят тебя, где стабильно вкусно и где всегда рад оказаться.",
    "sections": [
      {
        "heading": "Что делает ресторан «своим»",
        "body": "Психология лояльности к ресторанам хорошо изучена. Три главных фактора: постоянство (ожидаемый уровень каждый раз), узнавание (персонал помнит, что вы любите) и место (пространство, в котором комфортно). В «Парусах на крыше» все три фактора накапливаются годами: рестораны работает с 2009 года, у него есть постоянные гости, которые приходят ежемесячно.",
        "list": [
          "15 лет работы — гости, которые помнят, как всё начиналось",
          "Персонал помнит постоянных гостей и их предпочтения",
          "Стабильный рейтинг 5,0 — постоянство как характеристика",
          "Традиционные вечера с музыкой — ритм, к которому привыкают"
        ]
      },
      {
        "heading": "Традиции постоянных гостей",
        "body": "У «Парусов» есть гости, которые приходят каждую пятницу на живую музыку с бокалом вина. Есть пары, которые отмечают годовщину за одним и тем же столиком каждый год. Есть бизнес-гости, которые проводят деловые обеды здесь еженедельно. Это и есть признак ресторана, к которому хочется возвращаться.",
        "highlight": "Хотите стать постоянным гостем? Придите в первый раз, расскажите официанту о своих предпочтениях — и в следующий раз вас запомнят."
      },
      {
        "heading": "Почему «Паруса» удерживают гостей 15 лет",
        "body": "Причина проста: качество не снижается. Меню обновляется, но основа остаётся. Сервис не деградирует с годами — наоборот, накапливает опыт. Вид не надоедает: каждый сезон — новый вид из окна. И живая музыка — якорь, который заставляет планировать следующий визит заранее."
      }
    ],
    "cta": {
      "text": "Стать постоянным гостем «Парусов»",
      "href": "/"
    }
  },
  {
    "slug": "luchshiy-biznes-lanch-tsentr-spb",
    "title": "Лучший бизнес-ланч в центре СПб: топ-10 мест",
    "metaTitle": "Лучший бизнес-ланч в центре СПб — топ | Паруса на крыше",
    "metaDescription": "Лучший бизнес-ланч в центре Санкт-Петербурга. Где вкусно и недорого пообедать? «Паруса на крыше» — бизнес-ланч от 590 ₽ с панорамным видом.",
    "keywords": "лучший бизнес-ланч центр спб, топ бизнес-ланч петербург, бизнес-ланч рейтинг спб",
    "date": "2026-06-11",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Бизнес-ланч в центре Петербурга — ежедневный выбор тысяч людей. Разброс качества огромный. Собрали критерии хорошего бизнес-ланча и нашли, где они реализованы.",
    "sections": [
      {
        "heading": "Критерии хорошего бизнес-ланча",
        "body": "Пять критериев: цена (до 700 ₽ — хорошо, до 900 ₽ — приемлемо), состав (суп или закуска + горячее + напиток), качество продуктов (не замороженное, не разогретое), скорость (15–20 минут от заказа до подачи), атмосфера (не столовая). «Паруса на крыше» закрывают все пять: бизнес-ланч от 590 ₽ с авторской кухней и видом на Петербург — редкое сочетание.",
        "list": [
          "От 590 ₽ — одна из лучших цен в центре при этом качестве",
          "Авторская кухня даже в обеденном формате",
          "Быстрая подача — ориентированы на обеденный поток",
          "Вид на Петербург — уникальный бонус к обеду"
        ]
      },
      {
        "heading": "Почему бизнес-ланч с видом — ценность",
        "body": "Обеденный перерыв — время, когда мозг переключается. Вид на Казанский собор и крыши Петербурга — лучший способ провести эту «перезагрузку». Гости, которые обедают в «Парусах» регулярно, часто отмечают: вид меняет качество второй половины рабочего дня.",
        "highlight": "Пиковое время бизнес-ланча: 13:00–14:00. Для спокойного обеда приходите к 12:00 или после 14:30."
      },
      {
        "heading": "Как использовать бизнес-ланч для деловых встреч",
        "body": "Бизнес-ланч — удобный формат для деловых встреч: ограниченное время (45–60 минут), умеренная стоимость, нейтральная атмосфера. В «Парусах» при деловом ланче рекомендуем предупредить официанта — он будет деликатнее в обслуживании и не будет отвлекать разговор."
      }
    ],
    "cta": {
      "text": "Попробовать бизнес-ланч",
      "href": "/menu"
    }
  },
  {
    "slug": "restorany-sluzhba-servisa-peterburg",
    "title": "Рестораны с лучшим сервисом в Петербурге",
    "metaTitle": "Рестораны с лучшим сервисом в Петербурге — Паруса на крыше",
    "metaDescription": "Рестораны Санкт-Петербурга с лучшим обслуживанием. Что такое хороший ресторанный сервис и где его найти. «Паруса на крыше» — 15 лет профессионального сервиса.",
    "keywords": "лучший сервис ресторан петербург, хороший сервис ресторан спб, рестораны обслуживание петербург",
    "date": "2026-06-12",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Сервис в ресторане — то, что замечают все, но редко формулируют. Хороший официант не мешает разговору, но всегда рядом, когда нужен. Плохой — либо пропадает, либо навязывается.",
    "sections": [
      {
        "heading": "Признаки хорошего ресторанного сервиса",
        "body": "Критерии: скорость реакции (появляется, когда нужен, не когда удобно ему), знание меню (может объяснить состав блюда и дать рекомендацию), деликатность (не мешает разговору), память (запоминает предпочтения постоянных гостей). В «Парусах на крыше» сервис формировался 15 лет — это не случайный набор людей, а команда с накопленным опытом и рейтингом 5,0 как результатом.",
        "list": [
          "Официант появляется по взгляду — не навязывается",
          "Знает меню детально — не читает с листа",
          "Деликатно ведёт себя при романтических/деловых визитах",
          "Помнит постоянных гостей"
        ]
      },
      {
        "heading": "Как сервис влияет на впечатление от ресторана",
        "body": "Исследования показывают: гости чаще упоминают сервис в положительных отзывах, чем кухню. Хорошее блюдо, поданное равнодушно, оценивается хуже, чем среднее блюдо с вниманием и заботой. В «Парусах» в отзывах гости регулярно упоминают конкретных официантов — признак того, что сервис заметен и запоминается.",
        "highlight": "Хотите лучший сервис: бронируйте и указывайте повод при бронировании. Персонал готовится к особым событиям заранее."
      },
      {
        "heading": "Ожидания vs. реальность",
        "body": "Честное предупреждение: в загруженный вечер в пятницу или субботу время ожидания между заказом и подачей может быть чуть дольше. Это нормально для ресторана с живой музыкой и полным залом. Если важна скорость — приходите в будни или в ранний вечер."
      }
    ],
    "cta": {
      "text": "Убедиться в сервисе лично",
      "href": "/"
    }
  },
  {
    "slug": "restorany-zhivaya-muzyka-spb-top",
    "title": "Топ ресторанов с живой музыкой в СПб",
    "metaTitle": "Топ рестораны с живой музыкой в СПб — Паруса на крыше",
    "metaDescription": "Рестораны с живой музыкой в Санкт-Петербурге. Джаз, вокал, классика. «Паруса на крыше» — регулярные выступления по расписанию, панорама города. Афиша.",
    "keywords": "рестораны живая музыка спб топ, ресторан живая музыка петербург, джаз ресторан спб",
    "date": "2026-06-12",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Рестораны с живой музыкой в Петербурге — отдельная категория заведений. Здесь ужин становится вечером, а вечер — событием.",
    "sections": [
      {
        "heading": "Живая музыка в ресторане: форматы",
        "body": "В Петербурге рестораны с живой музыкой предлагают разные форматы: джазовый клуб (музыка на первом плане, еда — второстепенна), ресторан с фоновой живой музыкой (музыка создаёт атмосферу, не перебивая разговор), концертная площадка с кухней. «Паруса на крыше» — второй формат в лучшем проявлении: живой джазовый дуэт или трио играет вполголоса, создавая атмосферу без конкуренции с разговором.",
        "list": [
          "Расписание концертов в разделе «Афиша»",
          "Джазовые дуэты и трио — регулярно по пятницам и субботам",
          "Авторские выступления — несколько раз в месяц",
          "Живая музыка на мероприятия — по запросу и заказу"
        ]
      },
      {
        "heading": "Почему живая музыка в «Парусах» — особенная",
        "body": "Сочетание живой музыки с панорамным видом на Петербург создаёт то, что сложно описать словами: вы слышите джаз, видите купола и крыши города — и это работает как единый опыт. Именно поэтому пятничные вечера в «Парусах» бронируются заранее.",
        "highlight": "Проверьте афишу до бронирования — если совпадёте с конкретным выступлением, вечер будет особенным. Расписание: /afisha или по телефону."
      },
      {
        "heading": "Как бронировать вечер с музыкой",
        "body": "При бронировании на вечер с живой музыкой: укажите, что хотите попасть на конкретное выступление. Лучшие столики (у окна с видом + рядом со сценой) уходят первыми. Бронируйте за 5–7 дней. Минимального заказа для прослушивания нет — просто ужинаете и наслаждаетесь."
      }
    ],
    "cta": {
      "text": "Посмотреть афишу концертов",
      "href": "/afisha"
    }
  },
  {
    "slug": "khoroshee-mesto-2026-restoran-spb",
    "title": "Хорошее место 2026 на Яндекс Картах: что это значит",
    "metaTitle": "Хорошее место 2026 на Яндекс Картах — что это | Паруса на крыше",
    "metaDescription": "Что значит звание «Хорошее место» на Яндекс Картах? Как его получают и почему это важно при выборе ресторана. «Паруса на крыше» — «Хорошее место 2026».",
    "keywords": "хорошее место 2026 яндекс карты ресторан, хорошее место яндекс что значит, хорошее место ресторан спб",
    "date": "2026-06-12",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "«Хорошее место» от Яндекс Карт — значок, который видят миллионы пользователей при поиске ресторанов. Что он означает и почему «Паруса на крыше» его получили.",
    "sections": [
      {
        "heading": "Что такое «Хорошее место» на Яндекс Картах",
        "body": "«Хорошее место» — специальная метка от Яндекс Карт, которую автоматически присваивают заведениям на основе совокупности показателей: рейтинг (минимум 4,5+), количество отзывов (значительный объём), свежесть отзывов (активная аудитория в последние месяцы), качество ответов организации на отзывы. Присваивается ежегодно — «Хорошее место 2026» означает актуальные данные.",
        "list": [
          "Рейтинг: минимум 4,5+ (у «Парусов» — 5,0)",
          "Количество отзывов: существенный объём (у «Парусов» — 2 606)",
          "Актуальность: отзывы приходят регулярно",
          "Реакция на отзывы: ресторан отвечает и учитывает обратную связь"
        ]
      },
      {
        "heading": "Почему «Паруса» получают его каждый год",
        "body": "Звание «Хорошее место» пересматривается ежегодно — это не пожизненная награда. «Паруса» держат его из года в год, потому что качество стабильно: отзывы приходят постоянно, рейтинг не снижается, аудитория активная.",
        "highlight": "«Хорошее место» — надёжный ориентир при выборе ресторана. Не фиксируйтесь только на рейтинге цифрой — смотрите на объём отзывов: при 2 600+ это статистически значимый результат."
      },
      {
        "heading": "Как «Хорошее место» помогает при выборе",
        "body": "Практическое использование: когда ищете ресторан в незнакомом районе, фильтр «Хорошее место» убирает 80% неудачных вариантов. Среди оставшихся выбирайте по: количеству отзывов, дате последних отзывов (должны быть свежие), конкретным упоминаниям блюд (хорошая кухня = гости называют конкретные блюда)."
      }
    ],
    "cta": {
      "text": "Убедиться лично: забронировать стол",
      "href": "/"
    }
  },
  {
    "slug": "restorany-s-vidom-zaklinenie-spb",
    "title": "Видовые рестораны Петербурга: где лучший вид на город",
    "metaTitle": "Видовые рестораны Петербурга — где лучший вид | Паруса на крыше",
    "metaDescription": "Видовые рестораны Санкт-Петербурга: честный обзор. Где самый лучший вид на исторический центр? «Паруса на крыше» — 300° панорама с 6-го этажа Olympic Plaza.",
    "keywords": "видовые рестораны петербург, ресторан лучший вид спб, панорамный ресторан лучший вид петербург",
    "date": "2026-06-13",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_clouds.webp",
    "lead": "Петербург — один из самых красивых городов мира с высоты. Видовые рестораны дают возможность совместить хороший ужин с этим видом. Разбираем, где вид действительно лучший.",
    "sections": [
      {
        "heading": "Как оценивать вид из ресторана",
        "body": "Вид можно оценить по нескольким параметрам: угол обзора (360°, 180°, 90° — чем шире, тем лучше), высота (чем выше, тем больше открывается), направление (запад — закаты, север — Казанский собор, юг и восток — крыши и шпили), близость к достопримечательностям. «Паруса на крыше» на 6-м этаже Olympic Plaza дают обзор около 300° — одну из самых широких панорам среди ресторанов центра.",
        "list": [
          "300° обзор — один из лучших среди ресторанов центра",
          "Купола Казанского собора — прямо перед глазами",
          "Крыши центрального района — горизонт, уходящий вдаль",
          "Нева — в дальней перспективе на севере"
        ]
      },
      {
        "heading": "Что такое «хороший вид» субъективно",
        "body": "Хороший вид из ресторана — тот, который создаёт ощущение присутствия в особом месте. Это достигается, когда вид достаточно широкий (не одно окно), достаточно интересный (есть детали: купола, шпили, улицы), и меняется во времени (закат, огни, сезоны). Все три условия выполняются в «Парусах».",
        "highlight": "Фотосессия в «Парусах»: попросите официанта сделать фото компании у панорамного окна — лучший кадр с видом на Петербург для Instagram."
      },
      {
        "heading": "Сравнение видовых ресторанов",
        "body": "Рестораны на набережной: вид на Неву с уровня земли, нет высоты. Рестораны в отелях: вид зависит от этажа и расположения, часто неоднозначный. «Паруса на крыше»: целенаправленно созданный видовой ресторан с 15-летней историей и подтверждённым рейтингом 5,0. Для тех, кто хочет именно «видовой ресторан» — это первый выбор."
      }
    ],
    "cta": {
      "text": "Забронировать лучший видовой стол",
      "href": "/"
    }
  },
  {
    "slug": "restorany-nevskiy-top",
    "title": "Топ ресторанов у Невского проспекта: лучшие места",
    "metaTitle": "Топ ресторанов у Невского проспекта СПб — Паруса на крыше",
    "metaDescription": "Лучшие рестораны рядом с Невским проспектом в Петербурге. Где поесть хорошо в этой зоне? «Паруса на крыше» — 5 минут от Невского, рейтинг 5,0.",
    "keywords": "рестораны невский проспект топ, лучшие рестораны невский петербург, где поесть у невского спб",
    "date": "2026-06-13",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Невский проспект — туристическое сердце Петербурга, где хорошие рестораны соседствуют с посредственными. Знать, куда именно идти — значит получить лучшее от этого района.",
    "sections": [
      {
        "heading": "Как искать хороший ресторан у Невского",
        "body": "Стратегия: не идти на Невский, а уходить с него на параллельные улицы — Марата, Владимирский, Рубинштейна, Загородный. Именно здесь лучшие рестораны без туристической наценки. Ул. Марата, 5 — «Паруса на крыше», 5 минут пешком от Невского: рейтинг 5,0, авторская кухня, панорамный вид.",
        "list": [
          "Ул. Марата, 5 (5 мин. от Невского) — «Паруса на крыше»",
          "Рейтинг 5,0 при 2 606 отзывах — лучший в зоне",
          "Авторская кухня при ценах, сопоставимых с обычными ресторанами",
          "Вид на Петербург — бонус, которого нет на самом Невском"
        ]
      },
      {
        "heading": "Маршрут от Невского до «Парусов»",
        "body": "От метро Маяковская: выход на ул. Марата, прямо 400 метров, Olympic Plaza на левой стороне. От Гостиного двора: ул. Садовая → ул. Марата, 10 минут пешком. От Невского у Казанского: ул. Казанская → ул. Марата, 7 минут.",
        "highlight": "Навигатор: введите «Olympic Plaza Санкт-Петербург» или «ул. Марата 5 Паруса на крыше» — выведет точно."
      },
      {
        "heading": "Что ожидает вас у «Парусов»",
        "body": "Вход в Olympic Plaza с ул. Марата → лифт на 6-й этаж → стойка ресторана. Если брони нет — уточните наличие свободных столиков. Если есть бронь — просто назовите имя. Первое, что увидите в зале — панорама Петербурга. Дальше — авторское меню и внимательный сервис."
      }
    ],
    "cta": {
      "text": "Забронировать стол у Невского",
      "href": "/"
    }
  },
  {
    "slug": "restorany-istoricheskoe-zdanie-spb",
    "title": "Рестораны СПб в историческом здании: атмосфера прошлого",
    "metaTitle": "Рестораны СПб в историческом здании — Паруса на крыше",
    "metaDescription": "Рестораны Санкт-Петербурга в исторических зданиях. Атмосфера прошлого и современная кухня. «Паруса на крыше» — ресторан в историческом центре с панорамой.",
    "keywords": "рестораны историческое здание спб, рестораны в историческом центре петербург, исторический ресторан спб",
    "date": "2026-06-13",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Петербург — город, где любое здание в историческом центре имеет историю. Рестораны в таких зданиях дают особое ощущение: современная кухня в пространстве с 200-летней историей.",
    "sections": [
      {
        "heading": "Почему историческая архитектура важна для ресторана",
        "body": "Ресторан в историческом здании или в историческом центре несёт дополнительный смысловой слой. Гость сидит там, где когда-то жили петербуржцы 19 века. Из окна — те же купола, что видели современники Пушкина и Достоевского. Это создаёт связь времён, которую не может дать ресторан в торговом центре на окраине.",
        "list": [
          "Olympic Plaza расположена в историческом центре Петербурга",
          "Из окон «Парусов» — виды на здания 18–19 веков",
          "Казанский собор (1811) на уровне взгляда из зала",
          "Исаакиевский собор (1858) на горизонте"
        ]
      },
      {
        "heading": "Историческая часть Петербурга вокруг ресторана",
        "body": "Ул. Марата и её окрестности — исторический Петербург в чистом виде: здания 18–19 веков, дворы-колодцы, мощёные улицы. Ресторан на 6-м этаже в этой части города смотрит на крыши, которые не менялись 100–200 лет. Это контекст, который не нужно создавать — он уже есть.",
        "highlight": "После ужина в «Парусах»: прогуляйтесь по ул. Марата и заглянете в один из дворов-колодцев — это настоящий Петербург без туристического лоска."
      },
      {
        "heading": "Кухня в историческом контексте",
        "body": "Авторская кухня «Парусов» учитывает петербургский контекст: блюда из локальных продуктов Северо-Запада — балтийская рыба, карельские грибы — создают гастрономическую связь с историей региона. Это не «русская кухня» в туристическом понимании, а современный взгляд на локальные традиции."
      }
    ],
    "cta": {
      "text": "Почувствовать исторический Петербург за ужином",
      "href": "/"
    }
  },
  {
    "slug": "restorany-devichnik-spb",
    "title": "Лучшие рестораны для девичника в СПб: выбираем место",
    "metaTitle": "Лучшие рестораны для девичника в СПб — Паруса на крыше",
    "metaDescription": "Лучшие рестораны для девичника в Санкт-Петербурге. Приватность, атмосфера, кухня. «Паруса на крыше» — панорамный ресторан для незабываемого девичника.",
    "keywords": "рестораны девичник спб, лучший ресторан девичник петербург, куда пойти девичник спб ресторан",
    "date": "2026-06-14",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Выбор ресторана для девичника — баланс между «особенным» и «комфортным». Место должно быть красивым (фотографии), приватным (своя атмосфера) и с хорошей едой и напитками.",
    "sections": [
      {
        "heading": "Критерии ресторана для девичника",
        "body": "Приватность: выделенная зона или отдельный зал — компания должна быть «сама по себе». Атмосфера: место, в котором хочется оставаться долго, а не уходить через час. Меню: хороший выбор лёгких блюд, коктейлей и вина — не только горячее. Фотографии: красивый фон (вид из окна, интерьер) — девичник обязательно фотографируют. «Паруса» закрывают все четыре критерия.",
        "list": [
          "Выделенная зона — только ваша компания",
          "Панорама Петербурга — лучший фон для фото девичника",
          "Карта коктейлей и вин — несколько вариантов для группы",
          "Живая музыка по выходным — атмосфера без организационных усилий"
        ]
      },
      {
        "heading": "Дополнительные опции для девичника",
        "body": "Дегустация вин: 4–6 позиций с кратким рассказом — организуется при заказе. Авторские коктейли с именами подружек — бармен готовит по запросу. Фотосессия у панорамных окон: закат или ночной Петербург — лучший момент. Живые цветы на столе для невесты — при бронировании.",
        "highlight": "Лучший момент для фотосессии: пятница 19:30–20:30 — закат над Петербургом через панорамные окна. Прекраснее любой фотостудии."
      },
      {
        "heading": "Бронирование девичника в «Парусах»",
        "body": "Бронируйте за 1–2 недели. Укажите количество человек, что это девичник и дату свадьбы (менеджер знает, как сделать вечер особенным для невесты). При желании дегустации или специальной программы — сообщите за 5–7 дней. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать девичник в «Парусах»",
      "href": "/banket"
    }
  },
  {
    "slug": "restorany-veranday-peterburg-leto",
    "title": "Рестораны с верандой в Петербурге летом: где хорошо",
    "metaTitle": "Рестораны с верандой в Петербурге летом — Паруса на крыше",
    "metaDescription": "Рестораны с верандой в Санкт-Петербурге летом. Где поесть на открытом воздухе? «Паруса на крыше» — открытая терраса с видом на исторический центр, май–сентябрь.",
    "keywords": "рестораны веранда петербург лето, ресторан веранда спб, летняя веранда ресторан петербург",
    "date": "2026-06-14",
    "category": "Гид по городу",
    "readTime": 6,
    "image": "/photos/terrace.webp",
    "lead": "Летняя веранда в Петербурге — примета сезона. Рестораны с хорошими верандами собирают очереди с первых тёплых дней. Разбираем, что предлагает город.",
    "sections": [
      {
        "heading": "Три типа летних веранд в Петербурге",
        "body": "Уличные: вдоль Невского, Рубинштейна, у кафе и кофеен. Шумные, нет вида, много людей — атмосферно, но не для особого вечера. Дворовые: в петербургских дворах-колодцах — тихие, но нет воздуха (закрытое пространство). Высотные: на крышах и верхних этажах — воздух, вид, тишина. «Паруса на крыше» предлагают третий тип: открытая терраса на 6-м этаже с видом на Казанский собор.",
        "list": [
          "Открытая терраса на 6-м этаже — воздух и вид",
          "Работает с мая по сентябрь в хорошую погоду",
          "Вид на купола и крыши — нет в других форматах веранд",
          "Закрытый зал рядом — при дожде переходите без потери атмосферы"
        ]
      },
      {
        "heading": "Белые ночи на открытой террасе",
        "body": "Главный аргумент: белые ночи в июне на открытой террасе «Парусов» — это ужин под светлым небом в 23:00 с видом на Петербург. Такой опыт невозможен ни на уличной веранде (шум), ни во дворе (нет неба). Только высотная терраса даёт полноту этого ощущения.",
        "highlight": "Июнь — белые ночи на открытой террасе. Бронируйте в мае: эти вечера одни из самых популярных в году. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Что заказывать на открытой террасе летом",
        "body": "Лёгкие закуски: карпаччо, гребешки, брускетты — хорошо в тепле. Холодные напитки: просекко, лёгкое белое вино, авторские лимонады. Горячее: рыбные блюда или лёгкие пасты — не слишком тяжёлое для летнего вечера. Десерт: сорбе или паннакота — лёгко и освежающе."
      }
    ],
    "cta": {
      "text": "Забронировать стол на летней веранде",
      "href": "/"
    }
  },
  {
    "slug": "gde-poyest-posle-ermitazha-spb",
    "title": "Где поесть после Эрмитажа в СПб: рестораны рядом",
    "metaTitle": "Где поесть после Эрмитажа в СПб — рестораны | Паруса на крыше",
    "metaDescription": "Рестораны рядом с Эрмитажем в Санкт-Петербурге. Где вкусно поесть после Эрмитажа? «Паруса на крыше» — 15 минут пешком, авторская кухня с видом на Петербург.",
    "keywords": "поесть после эрмитажа спб, рестораны рядом эрмитаж петербург, ресторан после музея эрмитаж",
    "date": "2026-06-14",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "После нескольких часов в Эрмитаже хочется двух вещей: сесть и поесть. Хороший ресторан рядом с музеем — идеальное завершение культурного дня.",
    "sections": [
      {
        "heading": "Рестораны рядом с Эрмитажем",
        "body": "Эрмитаж находится на Дворцовой набережной. Рестораны в шаговой доступности: много туристических вариантов у Дворцовой площади и на Невском, но лучшие рестораны — в нескольких минутах ходьбы в сторону центра. «Паруса на крыше» — 15 минут пешком от Эрмитажа через Невский (ул. Марата, 5): панорама Петербурга как итог культурного дня.",
        "list": [
          "От Эрмитажа до «Парусов»: 15 минут пешком по Невскому → ул. Марата",
          "Или такси: 5–7 минут",
          "Авторская кухня после культурного дня — достойное завершение",
          "Вид на Казанский собор — продолжение петербургских впечатлений"
        ]
      },
      {
        "heading": "Маршрут: Эрмитаж → ужин в «Парусах»",
        "body": "Эрмитаж (2–3 часа) → Дворцовая площадь (15 минут) → прогулка по Невскому до Казанского собора (20 минут) → ул. Марата → «Паруса на крыше» (6-й этаж Olympic Plaza). Итого от Эрмитажа до ресторана: 30–40 минут пешком с остановками.",
        "highlight": "Совет: после Эрмитажа ноги устали — закажите такси до Olympic Plaza (ул. Марата, 5). 5–7 минут и вы у цели."
      },
      {
        "heading": "Что заказывать после музейного дня",
        "body": "После длинного музейного дня хочется чего-то сытного и тёплого. Рекомендуем: крем-суп или горячая закуска → горячее блюдо (стейк на хоспере или паста) → десерт и кофе. Всё это — с видом на Петербург, который только что смотрели на картинах в Эрмитаже."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после Эрмитажа",
      "href": "/"
    }
  },
  {
    "slug": "restorany-kazanskiy-sobor-peterburg",
    "title": "Рестораны у Казанского собора в Петербурге",
    "metaTitle": "Рестораны у Казанского собора в Петербурге — Паруса на крыше",
    "metaDescription": "Рестораны рядом с Казанским собором в Санкт-Петербурге. Где поесть с видом на Казанский? «Паруса на крыше» — вид на купол собора с 6-го этажа.",
    "keywords": "рестораны казанский собор петербург, ресторан вид казанский собор, поесть у казанского собора спб",
    "date": "2026-06-15",
    "category": "Гид по городу",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Казанский собор — архитектурная доминанта Центрального района Петербурга. Рестораны в его окрестностях предлагают разные форматы, но немногие дают вид на сам собор сверху.",
    "sections": [
      {
        "heading": "Рестораны рядом с Казанским собором",
        "body": "Казанский собор стоит на пересечении Невского проспекта и Казанской улицы. Рестораны вокруг: много туристических на Невском, несколько хороших на прилегающих улицах. «Паруса на крыше» — 700 метров от Казанского, но с видом на купол сверху: с 6-го этажа Olympic Plaza собор виден на уровне колоннады.",
        "list": [
          "700 метров от Казанского собора",
          "Вид на купол с 6-го этажа — недоступно из ресторанов у подножия",
          "5 минут пешком от Казанского до ресторана",
          "Туристические рестораны у собора vs. авторская кухня «Парусов»"
        ]
      },
      {
        "heading": "Почему вид сверху лучше, чем рядом",
        "body": "Большинство ресторанов у Казанского собора смотрят на его фасад с уровня земли. «Паруса на крыше» дают другой ракурс: купол и верхняя часть колоннады — то, что нельзя увидеть с улицы. Это особый архитектурный опыт, доступный только с определённой высоты.",
        "highlight": "Фотосессия с видом на Казанский: лучшее время — дневной свет (12:00–15:00) или ночная подсветка (после 22:00). Попросите столик у северного окна."
      },
      {
        "heading": "Маршрут: Казанский собор → «Паруса»",
        "body": "От Казанского собора: выйдите на ул. Казанская → Дмитровский переулок → ул. Марата → Olympic Plaza. Или: от Невского по ул. Марата прямо 400 метров от метро Маяковская. Маршрут занимает 5–7 минут пешком."
      }
    ],
    "cta": {
      "text": "Забронировать стол с видом на Казанский собор",
      "href": "/"
    }
  },
  {
    "slug": "gde-poyest-turistam-peterburg-nedorogo",
    "title": "Где поесть туристам в Петербурге недорого: честный гид",
    "metaTitle": "Где поесть туристам в Петербурге недорого — Паруса на крыше",
    "metaDescription": "Где поесть туристам в Санкт-Петербурге без переплаты? Честный гид по ресторанам. «Паруса на крыше» — авторская кухня, вид на город, от 590 ₽.",
    "keywords": "поесть туристам петербург недорого, где поесть туристу спб, ресторан для туристов петербург",
    "date": "2026-06-15",
    "category": "Гид по городу",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Туристам в Петербурге легко попасть в ловушку: заплатить дорого за посредственную еду в красивом месте. Честный гид поможет избежать этого и найти настоящие рестораны.",
    "sections": [
      {
        "heading": "Как туристы теряют деньги в ресторанах",
        "body": "Три главные ошибки: 1. Ресторан на Невском по принципу «красиво снаружи»: вероятность разочарования высокая. 2. Обед в ресторане при музее или отеле: цены завышены на 30–50%. 3. Ресторан с официантом, зазывающим с улицы: признак низкого качества и агрессивного маркетинга.",
        "list": [
          "Правило: лучшие рестораны НЕ на Невском, а рядом с ним",
          "Рейтинг Яндекс Карт 4,7+ при 200+ отзывах — надёжный фильтр",
          "«Хорошее место» — маркер качества от Яндекс Карт",
          "Ул. Марата, 5 — «Паруса на крыше»: 5 минут от Невского, рейтинг 5,0"
        ]
      },
      {
        "heading": "Бюджетные стратегии для туристов",
        "body": "Бизнес-ланч (будни 12:00–16:00): лучшее соотношение цена/качество в любом ресторане. В «Парусах» — от 590 ₽. Обед дороже, ужин ещё дороже — это нормальная практика. Если хотите ужин в красивом месте по доступным ценам: средний чек 1 200–1 500 ₽/чел. в «Парусах» — разумно для панорамного ресторана.",
        "highlight": "Совет туристу: бизнес-ланч в «Парусах» в первый день — лучший способ понять, стоит ли возвращаться сюда на ужин. Бронировать не нужно, просто приходите в 12:00–14:00."
      },
      {
        "heading": "Что обязательно попробовать в Петербурге",
        "body": "Петербургская гастрономия: балтийская рыба (треска, лосось, корюшка весной), карельские грибы, северные ягоды в соусах и десертах. В «Парусах» всё это представлено в авторской интерпретации. Для туриста, который хочет попробовать «петербургскую кухню», — это правильный адрес."
      }
    ],
    "cta": {
      "text": "Попробовать бизнес-ланч с видом",
      "href": "/menu"
    }
  },
  {
    "slug": "restorany-gid-turisty-peterburg",
    "title": "Гид по ресторанам для туристов в Петербурге 2026",
    "metaTitle": "Гид по ресторанам для туристов в Петербурге 2026 — Паруса на крыше",
    "metaDescription": "Полный гид по ресторанам Петербурга для туристов 2026. Рейтинг, цены, кухня, советы. «Паруса на крыше» — главный выбор для особого вечера в Петербурге.",
    "keywords": "гид рестораны туристы петербург, ресторанный гид петербург 2026, рестораны петербург туристу",
    "date": "2026-06-15",
    "category": "Гид по городу",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Петербург принимает миллионы туристов ежегодно. Ресторанный сектор огромный — но ориентироваться в нём без помощи сложно. Этот гид поможет выбрать правильно.",
    "sections": [
      {
        "heading": "Районы и рестораны: ориентация на карте",
        "body": "Центральный район: самый богатый в плане ресторанов — от бюджетных бизнес-ланчей до авторских дегустаций. Петроградская сторона: местные любимые рестораны, менее туристично. Васильевский остров: студенческая атмосфера, доступные цены. Для туриста центральный район — лучшая стартовая точка.",
        "list": [
          "Центральный район: «Паруса на крыше», ул. Марата 5 — главная рекомендация",
          "Невский ≠ лучшие рестораны: идите на параллельные улицы",
          "Яндекс Карты с фильтром «Хорошее место» — быстрый выбор",
          "Рейтинг 5,0 при 2 600+ отзывах — высшая гарантия"
        ]
      },
      {
        "heading": "Типичные сценарии и рекомендации",
        "body": "День 1 (прибытие): бизнес-ланч в «Парусах» (590 ₽) — знакомство с городом с высоты. День 2 (прогулки): кофе и круассан в кофейне → обед у Казанского → ужин в «Парусах» (авторская кухня, вид). День 3 (специальный ужин): романтический или семейный ужин в «Парусах» с предварительным бронированием.",
        "highlight": "Правило туриста: 1 особый ужин в «Парусах» за поездку — это минимум. Записывайте адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж."
      },
      {
        "heading": "Что взять в ресторане как сувенир",
        "body": "Съедобные сувениры из Петербурга: корюшка (весной), балтийская рыба в закрытой упаковке, карельские конфитюры, северные ягодные настойки. В ресторане «Паруса» можно спросить у официанта о локальных продуктах в меню — это лучший способ получить гастрономический «сувенир» в виде нового вкуса."
      }
    ],
    "cta": {
      "text": "Забронировать главный ужин в Петербурге",
      "href": "/"
    }
  }
];
